import comp from "./ConfigureAIVoiceV3";
export default comp;
